// import React from 'react';
// import {
//   EuiFlexGroup,  EuiFlexItem,  EuiPanel,  EuiSpacer,  EuiText} from '@elastic/eui';

// function YTModal(props) {
//     var url =  props.videoURL;
//     var description = props.videoDescription;
//     if(url){
//       var videoId = url.match(/(?:https?:\/{2})?(?:w{3}\.)?youtu(?:be)?\.(?:com|be)(?:\/watch\?v=|\/)([^\s&]+)/);
//       var startTimeURL = new URLSearchParams(url);
//       var startTime = startTimeURL.get('t');
//       var srcPath ="https://www.youtube.com/embed/" + videoId[1] + (( videoId[1].includes('?')) ? "&" : "?") + "autoplay=1" + ((startTime) ? "&start=" + startTime : "");

//       return (
//             <iframe id="ytplayer" type="text/html" width="100%" height="405"
//             src={srcPath}
//             frameBorder="0" allowFullScreen>
//             </iframe>
//       )
//     }
//     if(!url){
//       var message = description != null ? description : "抱歉，沒找到您所選擇的項目。請前往原始連結獲取更多信息。"
//       return (
//               <>
//               <EuiSpacer></EuiSpacer>
//               <p><EuiText><span dangerouslySetInnerHTML={{__html:  message}}></span></EuiText></p>
//               <EuiSpacer></EuiSpacer>
//               </>
//        )
//     }
// } 

// export default YTModal
import React from 'react';
import {
  EuiSpacer,
  EuiText
} from '@elastic/eui';
import '../style.css';

function getYouTubeInfo(rawUrl) {
  try {
    const parsedUrl = new URL(rawUrl);
    let videoId = '';

    if (parsedUrl.hostname.includes('youtu.be')) {
      videoId = parsedUrl.pathname
        .replace(/^\/+/, '')
        .split('/')[0];
    } else if (
      parsedUrl.pathname.startsWith('/embed/')
    ) {
      videoId = parsedUrl.pathname.split('/')[2];
    } else {
      videoId = parsedUrl.searchParams.get('v') || '';
    }

    const rawStart =
      parsedUrl.searchParams.get('t') ||
      parsedUrl.searchParams.get('start');

    return {
      videoId,
      startTime: parseStartTime(rawStart)
    };
  } catch (error) {
    console.error('Invalid YouTube URL:', rawUrl, error);

    return {
      videoId: '',
      startTime: 0
    };
  }
}

function parseStartTime(value) {
  if (!value) {
    return 0;
  }

  if (/^\d+$/.test(value)) {
    return Number(value);
  }

  const hours =
    Number(value.match(/(\d+)h/)?.[1] || 0);

  const minutes =
    Number(value.match(/(\d+)m/)?.[1] || 0);

  const seconds =
    Number(value.match(/(\d+)s/)?.[1] || 0);

  return hours * 3600 + minutes * 60 + seconds;
}

function YTModal(props) {
  const url = props.videoURL;
  const description = props.videoDescription;

  if (url) {
    const {
      videoId,
      startTime
    } = getYouTubeInfo(url);

    if (!videoId) {
      return (
        <div className="yt-modal-message">
          <EuiSpacer size="m" />

          <EuiText>
            <p>
              抱歉，無法識別這個 YouTube 視頻連結。
            </p>
          </EuiText>

          <EuiSpacer size="m" />
        </div>
      );
    }

    const query = new URLSearchParams({
      autoplay: '1',
      playsinline: '1',
      enablejsapi: '1'
    });

    if (startTime > 0) {
      query.set('start', String(startTime));
    }

    const srcPath =
      `https://www.youtube.com/embed/${videoId}?${query.toString()}`;

    return (
      <div className="yt-modal-player-wrapper">
        <iframe
          id="ytplayer"
          className="yt-modal-player"
          title="YouTube video player"
          src={srcPath}
          frameBorder="0"
          allow="
            autoplay;
            encrypted-media;
            picture-in-picture;
            fullscreen
          "
          allowFullScreen
        />
      </div>
    );
  }

  const message =
    description != null
      ? description
      : '抱歉，沒找到您所選擇的項目。請前往原始連結獲取更多信息。';

  return (
    <div className="yt-modal-message">
      <EuiSpacer size="m" />

      <EuiText>
        <span
          dangerouslySetInnerHTML={{
            __html: message
          }}
        />
      </EuiText>

      <EuiSpacer size="m" />
    </div>
  );
}

export default YTModal;